<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.paymentReminder')"
    resource="payment_reminders"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/payment_reminders.js';

@Component
export default class PaymentReminders extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'sales_order_id_eq',
      'state_eq',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'sales_order',
      'state',
      'date',
      'amount',
      {
        key: 'percentage',
        renderCell: (h, { props: { value } }) => {
          return <span>{value}%</span>
        }
      },
      {
        key: 'days_until_due',
        renderCell: (h, { props: { scope: { row } } }) => {
          if (row.state === 'received') return <span>-</span>
          const days = row.days_until_due
          if (days === null || days === undefined) return <span>/</span>

          let text, tagType
          if (days < 0) {
            text = `已过期${Math.abs(days)}天`
            tagType = 'danger'
          } else if (days === 0) {
            text = '今天到期'
            tagType = 'danger'
          } else if (days === 1) {
            text = '明天到期'
            tagType = 'warning'
          } else if (days <= 3) {
            text = `${days}天后到期`
            tagType = 'warning'
          } else {
            text = `${days}天后到期`
            tagType = 'success'
          }

          return <el-tag type={tagType} size="small">{text}</el-tag>
        }
      },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [

    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'payment_reminders.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'payment_reminders.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      },
      row.can_receive && {
        component: 'confirmButton',
        props: {
          label: '确认已收款',
          // type: 'danger',
          can: 'payment_reminders.receive'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/payment_reminders/${row.id}/receive`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/payment_reminders',
    name: 'payment_reminders.index',
    component: PaymentReminders,
    props: {
      type: 'index',
    }
  },
  {
    path: '/payment_reminders/new',
    name: 'payment_reminders.new',
    component: PaymentReminders,
    props: {
      type: 'new',
    }
  },
  {
    path: '/payment_reminders/:id',
    name: 'payment_reminders.show',
    component: PaymentReminders,
    props: {
      type: 'show',
    }
  },
  {
    path: '/payment_reminders/:id/edit',
    name: 'payment_reminders.edit',
    component: PaymentReminders,
    props: {
      type: 'edit'
    }
  }
]
</script>
